module.exports = __webpack_public_path__ + "static/media/img2.bab7390d.jpg";